import React from 'react';
import '../../../Generals/Styles/FormContainerStyle.css';

const GeneralSubElement = ({ children }) => {
  return <>{children}</>;
};

export default GeneralSubElement;
